import { render, staticRenderFns } from "./batch-operation.vue?vue&type=template&id=5b18807e&"
import script from "./batch-operation.vue?vue&type=script&lang=js&"
export * from "./batch-operation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports